import { render, staticRenderFns } from "./smallTitle.vue?vue&type=template&id=4d5ccf81&scoped=true"
import script from "./smallTitle.vue?vue&type=script&lang=js"
export * from "./smallTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ccf81",
  null
  
)

export default component.exports